import { Chip, ChipProps, Tooltip } from "@mui/material"

type HospitalFlagChipProps = {
  value?: boolean | number | null,
  name?: string,
  tips?: string
} & ChipProps
export const HospitalFlagChip = ({
  value,
  name,
  tips,
  ...others
}: HospitalFlagChipProps) => {
  if (value === null || value === undefined || value === false) return <></>
  if (name) {
    if (tips) {
      return <Tooltip title={tips}><Chip label={name} {...others} /></Tooltip>
    } else {
      return <Chip label={name} {...others} />
    }
  } else {
    if (tips) {
      return <Chip label={tips} {...others} />
    } else {
      return <></>
    }
  }
}

